
 <!-- ------------------------------------------ Component view industrySectors with Feilds => By Eng Ahmed Abdelhameed Ali ------------------------------------------ -->

<div class="col-12 d-flex flex-wrap bg-white p-8">
  <div class="col-sm-6">
    <ng-container *ngFor="let item of allIndustrySector; let i = index; let even=even">
      <div class="accordion w-100 p-2" [ngStyle]="{'direction':lang=='ar'? 'rtl':'ltr'}" id="accordionPanelsStayOpenExample" *ngIf="even">
        <div class="accordion-item position-relative">
          <span class="color"></span>
          <h2 class="accordion-header d-flex justify-content-between align-items-center" [id]="'panelsStayOpen-heading' + item.id">
            <button  class="accordion-button"  type="button"  [class.collapsed]="true" (click)="control=control=='open'?'close':'open';getIndustryFields(item.id);"
                class="accordion-button no-background-change" data-bs-toggle="collapse" [attr.data-bs-target]="'#panelsStayOpen-collapse' + item.id"  
                [attr.aria-expanded]="i === 0 ? 'true' : 'false'"  [attr.aria-controls]="'panelsStayOpen-collapse' + item.id">
               <span> {{ item.name }}</span>
            </button>
            <span style="min-width: fit-content;">
              <!-- add feild inside sector  -->
              <i class="bi bi-plus-square fs-6 m-1" (click)="openControlFields('add-IndustrySectorFeild',item,'')"></i>
              <!-- this open model in app-domains &  edit the sector -->
              <i class="bi bi-pencil-square text-warning fs-6 m-1" (click)="openDomainForEdit(item)"></i>
              <!-- deleting sector -->
              <i class="bi bi-trash3 text-danger fs-6 m-1" (click)="showDelete(item.id,'industry-delete')"></i>
             </span>
          </h2>
          <div [id]="'panelsStayOpen-collapse' + item.id" class="accordion-collapse collapse" [attr.aria-labelledby]="'panelsStayOpen-heading' + item.id">
            <div class="accordion-body"> 
              <div class="industryField d-flex justify-content-between" *ngFor="let ele of item.feilds">
                <div class="d-flex align-items-center">  <p> {{ele.name}}</p> <p class="text-info p-1" *ngIf="ele.iafCode_22">( IAF Code : {{ele.iafCode_22}} )</p></div>
                <div>
                  <i class="bi bi-pencil-square text-warning fs-6 m-1" (click)="openControlFields('edit-IndustrySectorFeild',item,ele)"></i>
                  <i class="bi bi-trash3 text-danger fs-6 m-1" (click)="showDelete(ele.id,'feild-delete')"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="col-sm-6">
    <ng-container *ngFor="let item of allIndustrySector; let i = index; let odd=odd">
      <div class="accordion w-100 p-2" [ngStyle]="{'direction':lang=='ar'? 'rtl':'ltr'}" id="accordionPanelsStayOpenExample" *ngIf="odd">
        <div class="accordion-item position-relative">
          <span class="color"></span>
          <h2 class="accordion-header d-flex justify-content-between align-items-center" [id]="'panelsStayOpen-heading' + item.id">
            <button  class="accordion-button"  type="button"  [class.collapsed]="true" (click)="control=control=='open'?'close':'open';getIndustryFields(item.id);"
                class="accordion-button no-background-change" data-bs-toggle="collapse" [attr.data-bs-target]="'#panelsStayOpen-collapse' + item.id"  
                [attr.aria-expanded]="i === 0 ? 'true' : 'false'"  [attr.aria-controls]="'panelsStayOpen-collapse' + item.id">
               <span> {{ item.name }}</span>
            </button>
            <span style="min-width: fit-content;">
              <!-- add feild inside sector  -->
              <i class="bi bi-plus-square fs-6 m-1" (click)="openControlFields('add-IndustrySectorFeild',item,'')"></i>
              <!-- this open model in app-domains &  edit the sector -->
              <i class="bi bi-pencil-square text-warning fs-6 m-1" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="openDomainForEdit(item)"></i>
              <!-- deleting sector -->
              <i class="bi bi-trash3 text-danger fs-6 m-1" (click)="showDelete(item.id,'industry-delete')"></i>
             </span>
          </h2>
          <div [id]="'panelsStayOpen-collapse' + item.id" class="accordion-collapse collapse" [attr.aria-labelledby]="'panelsStayOpen-heading' + item.id">
            <div class="accordion-body"> 
              <div class="industryField d-flex justify-content-between" *ngFor="let ele of item.feilds">
                <div class="d-flex"> <p> {{ele.name}}</p> <p class="text-info p-1" *ngIf="ele.iafCode_22">( IAF Code : {{ele.iafCode_22}} )</p></div>
                <div>
                  <i class="bi bi-pencil-square text-warning fs-6 m-1" (click)="openControlFields('edit-IndustrySectorFeild',item,ele)"></i>
                  <i class="bi bi-trash3 text-danger fs-6 m-1" (click)="showDelete(ele.id,'feild-delete')"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>


